import { toast } from "react-toastify";
import { method, paths } from "../services/ServiceConstants";
import ServicesManagerAPICall from "../services/ServicesManagerAPICall";
import {
  handleGetIcvDataSlice,
  handleICVAzureFileService,
  handleICVGetCCEUsersDataSlice,
  handleICVGetCropsMastersDataSlice,
  handleICVGetDistrictDataSlice,
  handleICVGetDownLoadCSVDataSlice,
  handleICVGetFailedReportDataSlice,
  handleICVGetInfoDataSlice,
  handleICVGetLevel5DataSlice,
  handleICVGetLevel6DataSlice,
  handleICVGetMandalDataSlice,
  handleICVGetPMFBYVillagesDataSlice,
  handleICVGetPolicyReportDataSlice,
  handleICVGetSeasonsDataSlice,
  handleICVGetStatesDataSlice,
  handleICVGetSurveyStatusDataSlice,
  handleICVGetVillagesDataSlice,
  handleICVGetYearDataSlice,
  handleICVStatusUpdateSlice,
  hasError,
  startLoadingICV,
  stopLoadingICV,
  handleICVGetQCUsersDataSlice,
  handleReassignQCSlice,
  handleAssignQCSlice,
  handleOnHoldSurveySlice,
  handleBulkUnHoldSurveySlice,
} from "../redux/slices/icvActivitySlice";
import { ICV_STATUS } from "../utils/Constant";
import { getAdminTokenApi, getQCUsersFromKeycloak } from "../utils/AuthUtils";

// ICV STATE DATA API CALL
export const icvGetStatesDataAPICall = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_STATE_DATA,
        {},
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetStatesDataSlice(response));
          // dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

//ICV DISTRICT API CALL
export const icvGetDistrictsDataAPICall = (stateId: string | number | null) => {
  const body: Object = {
    stateId: stateId,
  };
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_DISTRICTS_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetDistrictDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

// ICV DISTRICT DATA API CALL
export const icvGetMandalDataAPICall = (
  stateId: string | number | null,
  districtId: string | number | null
) => {
  const body: Object = {
    stateId: stateId,
    districtId: districtId,
  };
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_MANDALS_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetMandalDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

// ICV PMFBYVILLAGE DATA API CALL

export const icvGetAllPMFBYVillagesDataAPICall = (
  stateId: number,
  districtId: number,
  mandalId: number
) => {
  const body: any = {
    stateId: stateId,
    districtId: districtId,
    mandalId: mandalId ?? null,
  };

  if (!mandalId) delete body.mandalId;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_PMFBY_VILLAGES_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetPMFBYVillagesDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

//ICV VILLAGES DATA API CALL

export const icvGetAllVillagesDataAPICall = (
  stateId: string | number | null,
  districtId: string | number | null,
  mandalId: string | number | null,
  level5Id?: string | number | null,
  level6Id?: string | number | null
) => {
  const body: any = {
    stateId: stateId,
    districtId: districtId,
    mandalId: mandalId ?? null,
    level5Id: level5Id,
    level6Id: level6Id
  };

  if (!mandalId) delete body.mandalId;
  if (!level5Id) delete body.level5Id;
  if (!level6Id) delete body.level6Id;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_VILLAGES_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetVillagesDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const icvGetAllLevel5DataAPICall = (
  stateId: string | number | null,
  districtId: string | number | null,
  mandalId: string | number | null
) => {
  const body: any = {
    stateId: stateId,
    districtId: districtId,
    mandalId: mandalId ?? null,
  };

  if (!mandalId) delete body.mandalId;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_LEVEL5_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetLevel5DataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const icvGetAllLevel6DataAPICall = (
  stateId: string | number | null,
  districtId: string | number | null,
  mandalId: string | number | null,
  level5Id: string | number | null
) => {
  const body: any = {
    stateId: stateId,
    districtId: districtId,
    mandalId: mandalId ?? null,
    level5Id: level5Id ?? null,
  };

  if (!mandalId) delete body.mandalId;
  if (!level5Id) delete body.level5Id;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_LEVEL6_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetLevel6DataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

//ICV SEASONS DATA API CALL
export const icvGetAllSeasonsDataAPICall = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_SEASONS_DATA,
        {},
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetSeasonsDataSlice(response));
          // dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const icvGetYearDataAPICall = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_YEAR_DATA,
        {},
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetYearDataSlice(response));
          // dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const icvGetCropBySearchAPICall = (
  cropName: string,
  stateId?: string | number | null,
  districtId?: string | number | null
) => {
  // Only add keys if they are provided
  const body: Object = {
    cropName: cropName,
    ...(stateId ? { stateId } : {}),
    ...(districtId ? { districtId } : {}),
  };

  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_CROPS_MASTER_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetCropsMastersDataSlice(response));
          // dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const icvGetCCEUsersApiCall = (
  stateName?: string,
  districtName?: string,
  mandalName?: string,
  mobileNumber?: string
) => {
  // Construct the body object, filtering out undefined values
  const body = {
    ...(stateName && { stateName }),
    ...(districtName && { districtName }),
    ...(mandalName && { mandalName }),
    ...(mobileNumber && { mobileNumber }),
  };

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      const response = await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_CCE_USERS_DATA,
        body,
        true,
        false,
        true
      );

      if (response.statusCode === 1) {
        dispatch(handleICVGetCCEUsersDataSlice(response));
        dispatch(stopLoadingICV());
        return response; // Return response for further usage
      } else {
        toast.error(response.statusMessage || "An error occurred");
        dispatch(stopLoadingICV());
        return null; // Return null on failure
      }
    } catch (error) {
      dispatch(hasError(error));
      toast.error("Failed to fetch data. Please try again later.");
      return null; // Return null on error
    } finally {
      dispatch(stopLoadingICV());
    }
  };
};

export const ICVSurveyorAssigne = (
  seasonId: string | number | null,
  year: string | number | null,
  stateId: string | number | null,
  districtId: string | number | null,
  mandalId: string | number | null,
  villageId: string[],
  assignedTo: string[]
) => {
  

  const body: any = {
    seasonId: seasonId,
    year: year,
    stateId: stateId,
    districtId: districtId,
    mandalId: mandalId,
    villageId: villageId,
    assignedTo: assignedTo,
  };
  // if (!villageId || villageId.length === 0) {
  //   toast.error("villageId is Required");
  // }
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.POST,
        paths.ICV_ASSIGN_SURVEYOR,
        JSON.stringify(body),
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          toast.success("Survey Assigned Successfully");
          dispatch(stopLoadingICV());
        } else {
          dispatch(stopLoadingICV());
          toast.error(response.statusMessage);
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getICVInfoAPICall = (
  limit: number,
  offset: number,
  stateId: number | null | string,
  districtId: number | null | string,
  mandalId: number | null | string,
  level5Id: string[],
  villageId: string[],
  season: number | null | string,
  cropId: string[],
  year: number | null | string,
  fromDate: string | undefined,
  toDate: string | undefined,
  userId: string,
  roleId: number,
  kmlId: string
) => {
  const body: any = {
    limit:limit,
    offset:offset,
    stateId: [stateId],
    districtId: [districtId],
    mandalId: mandalId,
    villageId: villageId,
    level5Id: level5Id,
    season: season,
    cropId: cropId,
    year: year,
    fromDate: fromDate,
    toDate: toDate,
    userId: userId,
    roleId: roleId,
    kmlId: kmlId?.trim()
  };

  if (!stateId) delete body.stateId;
  if (!districtId) delete body.districtId;
  if (!mandalId) delete body.mandalId;
  if (level5Id.length < 1) delete body.level5Id;
  if (villageId.length < 1) delete body.villageId;
  if (!season) delete body.season;
  if (cropId.length < 1) delete body.cropId;
  if (!year) delete body.year;
  if (!fromDate) delete body.fromDate;
  if (!toDate) delete body.toDate;
  if (!(kmlId?.length > 0)) delete body.kmlId;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_GET_INFO,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1 && Array.isArray(response.data)) {
          const data = response.data;
          dispatch(
            handleICVGetInfoDataSlice({
              data: data,
              count: data?.length,
            })
          );
          dispatch(stopLoadingICV());
        } else {
          dispatch(handleICVGetInfoDataSlice({ data: [], count: 0 }));
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
        
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const ncipSearchApiCall = (
  requestedColumns: [ncipApplicationId: string, ncipCropName: string],
  distinctOn: [ncipApplicationId: string],
  size: number,
  page: number,
  filters: {
    ncipYear: string[];
    iagriSeason: string[];
    iagriCropVillageId: string[];
    ncipSurveyNumber: string[];
  }
) => {
  const body: Object = {
    requestedColumns: requestedColumns,
    distinctOn: distinctOn,
    size: size,
    page: page,
    filters: filters,
  };
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.POST,
        paths.NCIP_SEARCH_INFO,
        JSON.stringify(body),
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(stopLoadingICV());
        } else {
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};
export const getICVDownloadCSV = (
  stateId: number | null | string,
  districtId: number | null | string,
  mandalId: number | null | string,
  villageId: string[],
  season: number | null | string,
  cropId: string[],
  fromDate: String | undefined,
  toDate: String | undefined,
  year: number | null | string,
  userId: string,
  roleId: number,
) => {
  const body: any = {
    stateId: [stateId],
    districtId: [districtId],
    mandalId: mandalId,
    villageId: villageId,
    seasonId: season,
    cropId: cropId,
    fromDate: fromDate,
    toDate: toDate,
    year: year,
    userId: userId,
    roleId: roleId,
  };
  if (!stateId) delete body.stateId;
  if (!districtId) delete body.districtId;
  if (!mandalId) delete body.mandalId;
  if (villageId.length < 1) delete body.villageId;
  if (!season) delete body.seasonId;
  if (cropId.length < 1) delete body.cropId;
  if (!fromDate) delete body.fromDate;
  if (!toDate) delete body.toDate;
  if (!year) delete body.year;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_DOWNLOAD_CSV,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetDownLoadCSVDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          dispatch(stopLoadingICV());
          if(response.statusMessage) {
            toast.error(`${response.statusMessage}`);
          }
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const getICVPolicyReport =(
  stateId: number | null | string,
  districtId: number | null | string,
  mandalId: number | null | string,
  villageId: string[],
  season: number | null | string,
  cropId: string[],
  fromDate: String | undefined,
  toDate: String | undefined,
  year: number | null | string,
  userId: string,
  roleId: number,
) => {
  const body: any = {
    stateId: [stateId],
    districtId: [districtId],
    mandalId: mandalId,
    villageId: villageId,
    seasonId: season,
    cropId: cropId,
    fromDate: fromDate,
    toDate: toDate,
    year: year,
    userId: userId,
    roleId: roleId,
  };
  if (!stateId) delete body.stateId;
  if (!districtId) delete body.districtId;
  if (!mandalId) delete body.mandalId;
  if (villageId.length < 1) delete body.villageId;
  if (!season) delete body.seasonId;
  if (cropId.length < 1) delete body.cropId;
  if (!fromDate) delete body.fromDate;
  if (!toDate) delete body.toDate;
  if (!year) delete body.year;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_POLICY_REPORT,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
         dispatch(handleICVGetPolicyReportDataSlice(response));
          dispatch(stopLoadingICV());
        } else {
          dispatch(stopLoadingICV());
          if(response.statusMessage) {
            toast.error(`${response.statusMessage}`);
          }
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const icvAzureApiserviceApiCall = (imagePath: string | null) => {
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_AZURE_FILE_SERVICE + imagePath,
        {},
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          // return response
          dispatch(handleICVAzureFileService(response));
          dispatch(stopLoadingICV());
        } else {
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};


export const getICVDataAPICall = (
  limit: number,
  offset: number,
  stateId: number | null | string,
  districtId: number | null | string,
  mandalId: number | null | string,
  villageId: string[],
  season: number | null | string,
  cropId: string[],
  year: number | null | string,
  fromDate: string | undefined,
  toDate: string | undefined,
  surveyStatus: number | null | string,
  level5Id: string[],
  searchQuery: string,
  qcName: any,
  userId: string,
  roleId: number,
  kmlId: string,
  isUpdated: boolean
) => {
  const body: any = {
    limit:limit,
    offset:offset,
    stateId: [stateId],
    districtId: [districtId],
    mandalId: mandalId,
    villageId: villageId,
    season: season,
    cropId: cropId,
    year: year,
    fromDate: fromDate,
    toDate: toDate,
    icvStatus: surveyStatus,
    level5Id: level5Id,
    surveyorMobileNumber: searchQuery,
    qcMailId: qcName?.email,
    userId: userId,
    roleId: roleId,
    kmlId: kmlId?.trim()
  };

  if (!stateId) delete body.stateId;
  if (!districtId) delete body.districtId;
  if (!mandalId) delete body.mandalId;
  if (villageId.length < 1) delete body.villageId;
  if (!season) delete body.season;
  if (cropId.length < 1) delete body.cropId;
  if (!year) delete body.year;
  if (!fromDate) delete body.fromDate;
  if (!toDate) delete body.toDate;
  if (!surveyStatus) delete body.icvStatus;
  if (level5Id.length < 1) delete body.level5Id;
  if (searchQuery?.length < 1) delete body.surveyorMobileNumber;
  if (!(qcName?.email?.length > 0)) delete body.qcMailId;
  if (!(kmlId?.length > 0)) delete body.kmlId;

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.GET_ICV_DATA,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1 && Array.isArray(response.data)) {
          const data = response.data;
          dispatch(
            handleGetIcvDataSlice({
              data: data,
              count: data?.length,
            })
          );
          dispatch(stopLoadingICV());
        } else {
          dispatch(handleGetIcvDataSlice({ data: [], count: 0 }));
          !isUpdated && toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
        
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const icvGetSurveyStatusDataAPICall = () => {
  return async (dispatch: any) => {
    try {
      await ServicesManagerAPICall.request(
        method.GET,
        paths.ICV_SURVEY_STATUS,
        {},
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleICVGetSurveyStatusDataSlice(response));
        } else {
          toast.error(response.statusMessage);
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

// --- UPDATED: minimal change to send null for empty imageQuality, imageQualityRemarks, additionalRemarks ---
export const updateQCFeedback = (
  icvId: string,
  icvStatusId: number | null,
  qcMailId: string,
  reviewedBy: string,
  updatedBy: string,
  imageQuality: string | null,
  imageQualityRemarks: string,
  cropSown: string | null,
  cropSownRemarks: string,
  cropName: string[],
  additionalRemarks: string 
) => {
  // helper to ensure empty strings/whitespace => null
  const toTrimmedOrNull = (val: unknown): string | null => {
    if (val === null || val === undefined) return null;
    if (typeof val !== "string") return null;
    const t = val.trim();
    return t.length ? t : null;
  };

  // Normalize ONLY the three requested fields
  const normImageQuality = toTrimmedOrNull(imageQuality);
  let normImageQualityRemarks = toTrimmedOrNull(imageQualityRemarks);
  let normAdditionalRemarks = toTrimmedOrNull(additionalRemarks);

  const body: any = {
    icvId: icvId,
    icvStatusId: icvStatusId,
    qcMailId: qcMailId,
    reviewedBy: reviewedBy,
    updatedBy: updatedBy,
    qcRemarks: {
      imageQuality: normImageQuality,                       // null if empty
      imageQualityRemarks: normImageQualityRemarks,         // null if empty (may be deleted below if acceptable)
      cropSown: cropSown,                                   // unchanged to avoid breaking existing logic
      cropSownRemarks: cropSownRemarks,                     // unchanged (may be deleted below if yes)
      cropName: cropName?.length > 0 && (typeof cropName === 'string' ? [cropName] : cropName), // preserved as-is
      additionalRemarks: normAdditionalRemarks              // null if empty
    }
  };

  // Preserve existing conditional deletions (do not alter)
  if (imageQuality?.toLowerCase() === 'acceptable') delete body.qcRemarks.imageQualityRemarks;
  if (cropSown?.toLowerCase() === 'yes') delete body.qcRemarks.cropSownRemarks;
  if (cropSown?.toLowerCase() === 'no') delete body.qcRemarks.cropName;  

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.PUT,
        paths.QC_REVIEW,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1 && response.data === 1) {
          const data = response;
          if(response.statusMessage === 'ICV Updated Successfully'){
             body?.icvStatusId === ICV_STATUS.COMPLETED && toast.success('ICV has been completed successfully');
             body?.icvStatusId === ICV_STATUS.REASSIGNED && toast.success('ICV has been reassigned successfully'); 
          }        
          dispatch(handleICVStatusUpdateSlice(response));
        } else {
          dispatch(handleICVStatusUpdateSlice(response));
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
        
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
};

export const icvGetQCUsersAPICall = () => {
  return async (dispatch: any) => {
    try {
      const { token: adminToken } = await getAdminTokenApi();
      const qcUsers = await getQCUsersFromKeycloak(adminToken);
      dispatch(handleICVGetQCUsersDataSlice({ data: qcUsers }));      
    } catch (error) {
      console.error('Error fetching QC users:', error);
      dispatch(handleICVGetQCUsersDataSlice({ data: [] }));
    }
  };
};

export const reassignQCApi = (
  icvIdList: string[],
  qcMailId: string,
  qcName: string,
  createdBy: string,
  reassignRemarks: string
) => {
  const body: any = {
    icvId: icvIdList,
    qcMailId: qcMailId,
    qcName: qcName,
    createdBy: createdBy,
    isReassigned: true,
    reassignRemark: reassignRemarks
  };

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.PUT,
        paths.REASSIGN_QC,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleReassignQCSlice(response));
          toast.success('QC has been reassigned successfully');
        } else {
          dispatch(handleReassignQCSlice(response));
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
        
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export const assignQCApi = (
  icvIdList: string[],
  qcMailId: string,
  qcName: string,
  createdBy: string,
) => {
  const body: any = {
    icvId: icvIdList,
    qcMailId: qcMailId,
    qcName: qcName,
    createdBy: createdBy,
    isReassigned: false
  };

  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.POST,
        paths.ASSIGN_QC,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          dispatch(handleAssignQCSlice(response));
          toast.success(response.statusMessage);
        } else {
          dispatch(handleAssignQCSlice(response));
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
        
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export const onholdQCApi = (
  icvIds: string[],
  status: number,
  qcHoldRemarks: string | null,
  updatedBy: string
) => {
  const body: any = {
    icvIds: icvIds,
    status: status,
    qcHoldRemarks: qcHoldRemarks,
    updatedBy: updatedBy
  };
  return async (dispatch: any) => {
    dispatch(startLoadingICV());
    try {
      await ServicesManagerAPICall.request(
        method.PUT,
        paths.ON_HOLD,
        body,
        true,
        false,
        true
      ).then(async (response) => {
        if (response.statusCode === 1) {
          if(body.status === ICV_STATUS.ON_HOLD) {
            dispatch(handleOnHoldSurveySlice(response));
            toast.success('Survey has been moved to QC On Hold successfully');
          }
          else if (body.status === ICV_STATUS.QC_IN_PROGRESS) {
            dispatch(handleBulkUnHoldSurveySlice(response));
            toast.success('Survey(s) have been moved to QC In Progress successfully');
          }
        } else {
          if(body.status === ICV_STATUS.ON_HOLD) {
            dispatch(handleOnHoldSurveySlice(response));
          }
          else if (body.status === ICV_STATUS.QC_IN_PROGRESS) {
            dispatch(handleBulkUnHoldSurveySlice(response));
          }
          toast.error(response.statusMessage);
          dispatch(stopLoadingICV());
        }
      });
    } catch (error) {
      dispatch(hasError(error));
    }
  }
}

